import type { SelectedBrandliveEvent } from '@/types/projects.types';

const evEndMap: Map<SelectedBrandliveEvent, number> = new Map();
export const eventEnd = (event: SelectedBrandliveEvent) => {
  const cached = evEndMap.get(event);
  if (cached) return cached;

  let maxTimestamp = 0;

  for (const session of event.sessions) {
    if (session.timestamp) {
      maxTimestamp = Math.max(maxTimestamp, session.timestamp);
    }
  }

  evEndMap.set(event, maxTimestamp);
  return maxTimestamp;
};
